module.exports = __webpack_public_path__ + "fonts/IdeaBuddyFont.d0dbb52c.woff";